import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Input, Label, Button, Form } from "reactstrap";
import { get, put, post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate, useParams } from "react-router-dom";
import Loader from "common/loader";
import { SHOW_DELIVERY_TYPE, UPDATE_DELIVERY_TYPE, LANGUAGES_SEARCH } from "helpers/api_endpoints";



//meta title
document.title = "Edit Delivery Type";

const EditDeliveryType = () => {
    const [loading, setLoading] = useState(true);
    const params = useParams();
    const [id, setid] = useState('');
    const [name, setName] = useState('');
    const [valued, setValued] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [status, setStatus] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        post(`${LANGUAGES_SEARCH}`,{status:1})
            .then(response => {
                setLanguages(response.data);
                // console.log(languages);
                setLoading(false);
            })
            .catch(error => {
                navigate('/DeliveryTypes');
            })
    }, []);
    useEffect(() => {
        get(`${SHOW_DELIVERY_TYPE}/${params.id}`)
            .then(response => {
                const DeliveryType = response.data;
                setid(params.id);
                setValued(DeliveryType.named);
                setName(DeliveryType.name);
                setStatus(DeliveryType.status);
                setLoading(false);
            })
            .catch(error => {
                navigate('/DeliveryTypes');
            })
    }, [languages]);

    const handleSubmit = () => { 
        put(UPDATE_DELIVERY_TYPE, { id, name, status })
            .then(response => {
                if (response.code == 200) {
                    navigate('/delivery-types', { state: { successMsg: 'Language Updated SuccessFully' } });
                }
            })
            .catch(error => {
                console.log(error.response);
            })
    }

    const handleName = (languageId,value) => {
        if(!valued.title){
            setValued({"title":[{"1":""}]});
            return;  
        } 
        const ln = valued.title.filter(el =>{
            return Object.keys(el)[0] == languageId;
        })
        
        if(ln==undefined || ln.length <1)
        {
            const ob = {};
            ob[languageId] = value;
            valued.title.push(ob);
        }
        else
        {
            ln[0][languageId] = value;
        }
        setName(JSON.stringify(valued));             
    }
    
    const getValued = (langId) =>{
        if(!valued || valued[0]==undefined) return {"title":"","content":""};
        return valued[0][Object.keys(valued[0]).find(el=>el===langId)] || {"title":"","content":""}

    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="DeliveryTypes" breadcrumbItem="Edit DeliveryType" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        {loading ? <Loader></Loader> :
                                            <Row>
                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Name</Trans></Label>
                                                    <Input
                                                        name="name"
                                                        value={name}
                                                        className="form-control"
                                                        placeholder="Enter DeliveryType Name"
                                                        type="text"
                                                        onChange={(e) => setName(e.target.value)}
                                                        required ></Input>
                                                    <Input type="hidden" name="id"></Input>
                                                </div>

                                            {
                                                languages.map((language, index) => (
                                                    <Row key={index}>
                                                    <div className="form-group col-md-4 mt-2">
                                                        <Label className="form-label"><Trans>Name ({language.name})</Trans></Label>
                                                        <Input
                                                            name="name"
                                                            value={valued.title?valued.title.find(el => {return el[language.id]})?valued.title.find(el => {return el[language.id]})[language.id]:'':JSON.stringify(valued)}
                                                            className="form-control"
                                                            placeholder="Enter  Name"
                                                            type="text"
                                                            onChange={(e) => handleName(language.id,e.target.value)}
                                                            required={language.id==1||language.id==2?true:false} ></Input>
                                                    </div>
                                                </Row>
                                                ))
                                            }

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Status</Trans></Label>
                                                    <select className="form-control" onChange={(e) => setStatus(e.target.value)}>
                                                        <option value=''></option>
                                                        <option value={1} selected={status == 1}><Trans>Active</Trans></option>
                                                        <option value={0} selected={status != 1}><Trans>Non Active</Trans></option>
                                                    </select>
                                                </div>
                                                <div className="text-center  mt-4">
                                                    <Button type="submit" color="danger">
                                                        <Trans>Submit</Trans>
                                                    </Button>
                                                </div>
                                            </Row>
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default EditDeliveryType
